import { OfferSelection, Module, SapKey, Selection } from '../../types/types'
import { unnest } from 'ramda'

const getQuestionKeysByModule = (offerSelections: ReadonlyArray<OfferSelection>) => (module: Module) =>
  offerSelections.filter(question => question.module === module).map(question => question.key)

interface ModuleItems {
  module: Module
  items: SapKey[]
}

export const getModules = (offerSelections: ReadonlyArray<OfferSelection>): ModuleItems[] =>
  offerSelections.reduce((out: ModuleItems[], curr: OfferSelection, _, __) => {
    const idx = out.findIndex(v => v.module === curr.module)
    if (idx >= 0) {
      if (!out[idx].items.includes(curr.key)) {
        out[idx].items.push(curr.key)
      }
    } else {
      out.push({ module: curr.module, items: [curr.key] })
    }
    return out
  }, [])

export const getOrderedVisibleQuestionKeys = (offerSelections: ReadonlyArray<OfferSelection>): SapKey[] => {
  const getQuestionKeys = getQuestionKeysByModule(offerSelections)
  const visibleOfferSelections = offerSelections.filter(os => os.visibility === 'visible')
  return unnest(
    getModules(visibleOfferSelections)
      .map(m => m.items)
      .concat([getQuestionKeys('interaction')])
  )
}

export const arrayifySelections = (s: Selection | undefined): string[] => (!s ? [] : Array.isArray(s) ? s : [s])
